"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
var _colors = require("../../utils/colors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  base: _objectSpread(_objectSpread({}, theme.typography.subtitle2), {}, {
    // TODO: OVERRIDE
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 700,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.secondary.main,
      textDecoration: 'none'
    }
  }),
  header: {
    color: theme.palette.common.white,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontWeight: '400',
      //TODO: OVERRIDE
      fontSize: '1rem'
    }
  },
  footer: {
    color: theme.palette.common.white,
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(14.5),
    //TODO: OVERRIDE
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem'
    }
  },
  footer2: {
    color: (0, _colors.getRgba)(theme.palette.common.white, 0.6),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem'
    }
  }
}), {
  name: 'NavLink'
});
var _default = exports.default = useStyles;